import { useAuth } from "../../auth/useAuth";
import {loadAllLookupPages} from "../../hooks/useInventoryLookups";
import { useEffect, useState } from "react";
import type { KeyValue } from "../../models/KeyValue";
import { CustomerService } from "../../services/CustomerService";
import { OrderService } from "../../services/OrderService";
import type { Order } from "../../models/Order";
import { ProductService } from "../../services/ProductService";

export interface SaleDTO {
  Error: string;
  Customers: KeyValue[];
  Orders: Order[];
  Products: KeyValue[];
}
export function useSale(warehouseCode?: string): SaleDTO {
  const {hasPermission} = useAuth();
  const canReadOrders = hasPermission("Order.View");
  const [state, setState] = useState<SaleDTO>({
    Error: "",
    Customers: [],
    Orders: [],
    Products: [],
  });
  useEffect(() => {
    let active=true;
    void Promise.all([
      loadAllLookupPages(CustomerService().GetActivePartial),
      canReadOrders ? loadAllLookupPages(OrderService(warehouseCode).GetPayable) : Promise.resolve([]),
      loadAllLookupPages(ProductService().GetActivePartial),
    ]).then(([customers, orders, products]) =>
      active && setState({
        Error: "",
        Customers: customers,
        Orders: orders,
        Products: products,
      }),
    ).catch(()=>active && setState(current=>({...current,Error:"Could not load transaction options. Reload this page to try again."})));
    return () => {active=false;};
  }, [warehouseCode, canReadOrders]);
  return state;
}
